import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { getGoals } from 'actions';
import { getGuardianStudentDocumentation, getGuardianStudentDocumentFile } from 'actions/documents';
import { getReaderParameters } from 'actions/user';
import { setPageTitle } from 'actions/header';
import Block, { BlockContent, BlockWrapper } from 'components/Block/Block';
/* Import UI components */
import PostContent from 'components/Presentation/PostContent';
import { getDescription } from 'helpers/content';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'UI';
import { Immersive_Reader } from 'UI/Icons';
import { Link } from 'react-router-dom';
import { Block as ContentBlock, Icon, getActiveLanguage, translate } from '@haldor/ui';
var ImmersiveReader = require('@microsoft/immersive-reader-sdk');
var SingleDocument = /*#__PURE__*/function (_Component) {
  function SingleDocument(props) {
    var _this;
    _classCallCheck(this, SingleDocument);
    _this = _callSuper(this, SingleDocument, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      var activeStudent = _this.props.activeStudent;
      _this.setState({
        loading: true
      });
      _this.props.getGuardianStudentDocumentation(activeStudent.id, _this.props.match.params.documentId).then(function () {
        _this.props.setPageTitle(_this.props.activeDocument.title);
        _this.setState({
          loading: false
        });
      });
      if (_this.props.goals.length < 1) {
        _this.props.getGoals();
      }
    });
    _defineProperty(_this, "runImmersiveReader", function () {
      var activeDocument = _this.props.activeDocument;
      var data = {
        title: activeDocument.title,
        chunks: [{
          content: '<h1>' + activeDocument.title + '</h1>',
          mimeType: 'text/html'
        }, {
          content: getDescription(activeDocument.description),
          mimeType: 'text/html'
        }]
      };
      _this.props.getReaderParameters().then(function () {
        var reader = _this.props.reader;
        ImmersiveReader.launchAsync(reader.token, reader.subdomain, data, {
          uiLang: getActiveLanguage()
        })["catch"](function (error) {
          console.error('error', error);
          //trackImmersiveReaderError(error, currentUser.id);
        });
      });
    });
    _this.state = {
      token: null
    };
    return _this;
  }
  _inherits(SingleDocument, _Component);
  return _createClass(SingleDocument, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        activeDocument = _this$props.activeDocument,
        translate = _this$props.translate;
      var files = this.state.files;
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", {
          className: "single-task single-preschool_document"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }
      if (activeDocument != null) {
        return /*#__PURE__*/React.createElement("div", {
          className: "single-task single-preschool_document"
        }, /*#__PURE__*/React.createElement("div", {
          className: "single-section form left-side",
          style: {
            paddingTop: '0'
          }
        }, /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement("div", {
          className: "single-task-description"
        }, /*#__PURE__*/React.createElement("span", {
          className: "title"
        }, translate('Description')), /*#__PURE__*/React.createElement(Link, {
          to: "#",
          onClick: this.runImmersiveReader
        }, /*#__PURE__*/React.createElement("div", {
          className: "reader trigger"
        }, /*#__PURE__*/React.createElement(Immersive_Reader, null), " ", translate('Immersive Reader'))), /*#__PURE__*/React.createElement(PostContent, null, getDescription(activeDocument.description))), activeDocument.associatedGoals && activeDocument.associatedGoals.length > 0 ? /*#__PURE__*/React.createElement("div", null, activeDocument.associatedGoals.map(function (associatedGoal) {
          var goal = _this2.props.goals.find(function (t) {
            return t.id == associatedGoal.goalId;
          });
          if (goal != null) {
            return /*#__PURE__*/React.createElement("div", {
              key: goal.id,
              className: "goal-preview",
              "data-tooltip": goal.text,
              style: {
                backgroundColor: goal.colorCode
              }
            }, goal.title);
          }
          return null;
        })) : null), activeDocument.associatedFiles.length > 0 ? /*#__PURE__*/React.createElement(BlockWrapper, {
          cols: "2"
        }, /*#__PURE__*/React.createElement("div", {
          className: "preschool-gallery"
        }, activeDocument.associatedFiles.map(function (file, index) {
          var fileUrl = file.url;
          if (file.type.indexOf('image') > -1) {
            return /*#__PURE__*/React.createElement(Block, {
              key: "file-".concat(file.id, "-").concat(index)
            }, /*#__PURE__*/React.createElement("img", {
              src: fileUrl,
              style: {
                width: '100%',
                height: '100%',
                display: 'block',
                borderRadius: 'inherit'
              }
            }));
          }
          return /*#__PURE__*/React.createElement(Block, {
            key: "file-".concat(file.id, "-").concat(index)
          }, /*#__PURE__*/React.createElement("a", {
            href: fileUrl,
            className: "block-content",
            target: "_blank"
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              display: 'inline-block',
              width: '1.15rem',
              height: '1.15rem',
              position: 'relative',
              top: 3,
              marginRight: '0.55rem'
            }
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "File"
          })), file.name));
        }))) : null), /*#__PURE__*/React.createElement("div", {
          style: {
            clear: 'both'
          }
        }));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "single-task"
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '1rem 0'
        },
        className: "text--center color--meta weight--bold"
      }, this.props.translate("Something went wrong! We couldn't find what you were trying to reach!")))));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    activeStudent: state.User.activeStudent,
    user: state.User.user,
    activeDocument: state.documents.documentation,
    goals: state.base.goals,
    reader: state.User.reader,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  getGuardianStudentDocumentation: getGuardianStudentDocumentation,
  getGuardianStudentDocumentFile: getGuardianStudentDocumentFile,
  getGoals: getGoals,
  getReaderParameters: getReaderParameters,
  setPageTitle: setPageTitle
})(SingleDocument);